"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpStatusChip = void 0;
const calcOpStatus_1 = __importDefault(require("@opsbase/lib-op/helpers/calcOpStatus"));
const OpStatus_1 = __importStar(require("@opsbase/lib-op/OpStatus"));
const utils_1 = require("@opsbase/lib-time/utils");
const react_1 = __importDefault(require("react"));
const Chip_1 = __importDefault(require("../Chip"));
function OpStatusChip(props) {
    const { op } = props;
    const status = (0, calcOpStatus_1.default)(op);
    const label = status === OpStatus_1.default.NOT_DUE
        ? 'Due ' + (0, utils_1.humanizeFromNow)(op.completeBy)
        : (0, OpStatus_1.opStatusLabel)(status);
    return react_1.default.createElement(Chip_1.default, { fullWidth: true, multiline: true, centered: true, label: label, color: (0, OpStatus_1.opStatusColor)(status) });
}
exports.OpStatusChip = OpStatusChip;
exports.default = OpStatusChip;
